import './PageTitle.scss';

export interface PageTitleProps {
  title: string
}

export const PageTitle = ({title = 'Placeholder'}: PageTitleProps) => {
  return <span className="page-title">{title}</span>
}
